export const UNPAID_TRACKING_VIEWER_EMAILS = [
  'rhumphan@gmail.com',
  'vioshipping@gmail.com',
  'akiexpressvn@gmail.com',
];

export const canViewTrackingBeforePayment = (email) =>
  UNPAID_TRACKING_VIEWER_EMAILS.includes(String(email || '').trim().toLowerCase());
